import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable()
export class ConfigService {

  private company = new BehaviorSubject(null);

  constructor(private http: HttpService) {}

  public requestCompany = () => {
    const route = '/api/config/company';
    this.http.get(route, (response: any) => {
        this.company.next(response);
    });
  }

  /**
   * Gibt den Datensatz der Firma als Observable zurück
   *
   * @returns Observable<any>
   */
  public getCompany = (): Observable<any> => {
    return this.company.asObservable();
  }

}
